// extracted by mini-css-extract-plugin
export default {"infoBar":"InfoBar-module__infoBar-mmpNDi"};